import { flow } from 'fp-ts/function';
import { get, map } from 'lodash/fp';
import { createSelector } from 'reselect';
import { RouteName } from '@mews-commander/enums';
import { getProp, getStringProp } from '@mews/fp';
import { createAsyncMetaSelectors } from '@mews/framework';
import { ResolveRoute } from '@mews/routing';
import { Option } from '@mews-commander/legacy-data-structures';
import { getContainer } from '@mews-commander/legacy-app-instance';
import { getProductCategories } from '@mews-commander/legacy-entities/src/ducks/productCategories';
import { getRoutingRule } from '@mews-commander/legacy-entities/src/ducks/routingRules';
import { createEntityFormattedMetaSelector } from '@mews-commander/legacy-entities/src/selectors/form';
import { checkEnterprisePrivilege } from '@mews-commander/legacy-entities/src/selectors/session/privilegeChecks';
import { moduleSelector } from './module';

export const getProductCategoriesOptions = createSelector(
    getContainer,
    getProductCategories,
    (container, productCategories) => {
        const { appLocalizationComponent } = container();
        const { localizeProperty } = appLocalizationComponent;
        return map(({ id, names, descriptions }) =>
            Option({ value: id, label: localizeProperty(names), secondaryText: localizeProperty(descriptions) })
        )(productCategories);
    }
);

const getMeta = flow(moduleSelector, get('meta'));
export const [isFetching, hasFailed] = createAsyncMetaSelectors(getMeta);

export const getRoutingRuleFormattedMeta = createEntityFormattedMetaSelector(getRoutingRule);

export const getRoutingRuleIndexUrl = createSelector(
    getProp<ResolveRoute>()('resolveRoute'),
    getStringProp('enterpriseId'),
    (resolveRoute, enterpriseId) => resolveRoute(RouteName.RoutingRuleIndex, { query: { EnterpriseId: enterpriseId } })
);

export const checkRoutingRuleDetailPrivilege = (state: $TSFixMe, { routingRuleId, enterpriseId }: $TSFixMe) => {
    const routingRule = getRoutingRule(state, { id: routingRuleId, enterpriseId });

    return routingRule !== undefined && checkEnterprisePrivilege(state, { enterpriseId });
};
